import io from 'socket.io-client';
import Emitter from 'tiny-emitter';
function now() {
  return new Date().getTime();
}
const pageId = now();
const maxTimeLag = 600 * 1000;
/**
 * socketClient
 */
export class SocketClient extends Emitter {
  constructor({ url = '', token, dealerId, path = null }) {
    super();
    this.oppositeUser = {
      state: 0,
      ackTime: 0,
      sendTime: 0,
      timeout: 30000,
    };
    this.currentToUserId = '';
    this.handshakeData = null;
    this.heartTimer = null;
    const socket = this.initSocket({ url, token, dealerId, path });
    this.instance = socket;
    this.initSocketEvent();
  }
  /**
   * 初始化socket
   * @param {*} param0
   * @returns
   */
  initSocket({ url = '', token, dealerId, path = null }) {
    console.error('initSocket');
    const socket = io(url, {
      path: path,
      enablesXDR: true,
      withCredentials: true,
      transports: ['websocket'],
      query: {
        pageId,
        token: token || '',
        dealerId,
      },
      // reconnectionAttempts: 5
    });
    return socket;
  }
  /**
   * 初始化socket
   * @param {*} param0
   * @returns
   */
  initSocketEvent() {
    const socket = this.instance;

    socket.on('connect', () => {
      console.error('connect', socket.id);
      this.oppositeUser.state = 0;
      if (this.currentToUserId) {
        this.joinRoom();
      }
      this.createHeartTimer(500);
      this.emit('connect');
    });
    socket.on('heart', (sendTime) => {
      const state = this.oppositeUser.state;
      this.setOppositeUserState(1, sendTime);
      if (state === 0) {
        this.emit('oppositeJoin');
        setTimeout(() => {
          this.clearHeartTimer();
          this.createHeartTimer(5000);
        }, 1000);
      } else {
        const time = Math.abs(now() - sendTime);
        if (time > maxTimeLag) {
          this.emit('timeInconsistency', time);
        }
      }
    });

    socket.on('leaveRoom', (data) => {
      this.setOppositeUserState(0);
      this.emit('oppositeLeave');
      console.log('leaveRoom', data);
    });

    socket.on('events', (data) => {
      this.emit('events', data);
    });

    socket.on('disconnect', (reason) => {
      this.setOppositeUserState(0);
      this.clearHeartTimer();
      console.error('disconnect', reason);
      this.emit('disconnect', reason);
    });

    socket.io.engine.on('pong', () => {
      console.log('pong');
    });

    socket.io.on('ping', () => {
      console.log('received ping');
    });

    socket.io.engine.on('handshake', (data) => {
      this.handshakeData = data;
      console.log('handshake', data);
    });

    socket.on('error', (error) => {
      this.emit('error', { type: 'error', error });
      console.error('error', error);
    });

    socket.on('connect_error', (error) => {
      this.emit('error', { type: 'connect_error', error });
      console.error('connect_error', error);
    });

    socket.on('connect_timeout', (timeout) => {
      this.emit('error', {
        type: 'connect_timeout',
        error: new Error('链接超时' + timeout),
      });
      console.error('connect_timeout');
    });

    socket.on('reconnect_error', (error) => {
      this.emit('error', { type: 'reconnect_error', error });
      console.error('reconnect_error');
    });

    socket.on('reconnect_failed', (error) => {
      this.emit('error', { type: 'reconnect_failed', error });
      console.error('reconnect_failed');
    });

    window.addEventListener('beforeunload', () => {
      this.disconnect();
    });
    window.addEventListener('pagehide', () => {
      this.disconnect();
    });
  }
  /**
   * 创建心跳
   */
  createHeartTimer(ms) {
    this.heartTimer = setInterval(() => {
      const time = now() - this.oppositeUser.ackTime;
      if (this.oppositeUser.state === 1 && time > this.oppositeUser.timeout) {
        this.setOppositeUserState(0);
        this.emit('oppositeLeave');
      }
      this.sendHeart();
    }, ms);
  }
  /**
   * 清除心跳
   */
  clearHeartTimer() {
    window.clearInterval(this.heartTimer);
    this.heartTimer = null;
  }
  /**
   * 发送事件消息
   * @param {*} eventName  事件名称
   * @param {*} data  事件数据
   */
  send(eventName, data) {
    const socket = this.instance;
    const state = this.oppositeUser.state;
    if (socket && state === 1) {
      socket.emit(eventName, data, (ackData) => {
        console.log('ack', ackData);
      });
    }
  }

  /**
   * 设置对方用户信息
   * @param {*} currentToUserId
   */
  setToUserId(currentToUserId) {
    if (currentToUserId) {
      const socket = this.instance;
      this.currentToUserId = currentToUserId;
      if (socket.connected) {
        this.joinRoom();
      }
    }
  }
  joinRoom() {
    const socket = this.instance;
    if (this.currentToUserId) {
      socket.emit('joinRoom', this.currentToUserId, () => {
        this.sendHeart();
      });
    }
  }
  sendHeart() {
    const socket = this.instance;
    const sendTime = now();
    if (!socket) {
      return;
    }
    socket.emit('heart', sendTime, (serveTime) => {
      const delayTime = now() - sendTime;
      this.serveTime = serveTime + delayTime / 2;
      if (delayTime > 500) {
        this.emit('delayExcessive', delayTime);
      }
    });
  }

  /**
   * 设置对方在线状态
   * @param {*} state
   */
  setOppositeUserState(state, sendTime = 0) {
    this.oppositeUser.state = state;
    this.oppositeUser.ackTime = now();
    this.oppositeUser.sendTime = sendTime;
  }

  /**
   * 断开链接
   */
  disconnect() {
    if (this.instance) {
      this.instance.close();
      this.instance = null;
      this.off('connect');
      this.off('disconnect');
      this.off('events');
      this.off('oppositeJoin');
      this.off('oppositeLeave');
      this.off('error');
      this.off('timeInconsistency');
      this.off('delayExcessive');
    }
  }
}
